import script from "./orderDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./orderDetail.vue?vue&type=script&lang=ts&setup=true"

import "./orderDetail.vue?vue&type=style&index=0&id=638b1763&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-638b1763"]])

export default __exports__